import { Card, CardHeader, Skeleton, CardContent } from '@mui/material';

export const PostSkeleton = () => (
  <Card sx={{ boxShadow: 'unset' }} className="shadow-none">
    <CardHeader
      avatar={
        <Skeleton
          animation="wave"
          variant="circular"
          width={40}
          height={40}
          className="rounded-[20px]"
        />
      }
      title={
        <>
          <Skeleton
            animation="wave"
            height={10}
            width="40%"
            sx={{ marginBottom: 2 }}
          />
          <Skeleton animation="wave" height={10} width="20%" />
        </>
      }
    />
    <Skeleton
      sx={{ height: 190, margin: '0 20px' }}
      animation="wave"
      variant="rectangular"
    />
    <CardContent>
      <Skeleton animation="wave" height={10} sx={{ marginBottom: 2 }} />
      <Skeleton animation="wave" height={10} />
    </CardContent>
  </Card>
);
